import Button from "@material-ui/core/Button";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import React, { Component } from "react";

export class BackButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      onClick: props.onClick,
      caption: props.caption,
      type: props.type,
      name: props.name,
    };
  }

  onClick() {
    if (this.state.onClick) {
      this.state.onClick();
    }
  }

  render() {
    return (
      <Button
        type={this.state.type ? this.state.type : ""}
        variant="contained"
        // size="small"
        id="ptsButton"
        style={{
          marginRight: "0.7rem",
          textTransform: "capitalize",
        }}
        onClick={this.onClick.bind(this)}
        startIcon={<ArrowBackIcon />}
      >
        {this.state.name ? this.state.name : "Back"}
      </Button>
    );
  }
}
export default BackButton;
